import type { RozetAnlami } from '../theme';
import { Rozet } from '../sozlesme';

/**
 * DÖF SAYACI — OLAYIN DURUM GÖSTERGESİ (✏️ T2·0 — Kapsam §16.8/7-j.5).
 *
 * Kapanış bir işlem değil, türetmedir; kullanıcı "kapalı mı"yı bu sayaçtan
 * okur: *kapalı DÖF / toplam DÖF*. Renk kararı TEK yerde (bu yüklem) — liste
 * satırı ve künye aynı bileşeni çizer; ekran saymaz, sunucu sayar
 * (`toplamDofSayisi` · `acikDofSayisi`).
 *
 *   0/0 → `bilgi`  (renksiz — DÖF yok, olay AÇIK; 0/0 raporda da açıktır)
 *   x/x → `olumlu` (tümü kapalı — olay TÜRETİLMİŞ kapalı)
 *   0/x → `engel`  (hiçbiri kapanmamış)
 *   kısmi → `dikkat`
 * Semantik set G7 (`theme.ts`); ekran renk yazmaz, anlam yazar.
 */
export function dofSayaciAnlami(toplam: number, acik: number): RozetAnlami {
  if (toplam === 0) return 'bilgi';
  if (acik === 0) return 'olumlu';
  if (acik === toplam) return 'engel';
  return 'dikkat';
}

export function DofSayaci({
  toplam,
  acik,
  testId,
  bosCizilmez = false,
}: {
  toplam: number;
  acik: number;
  testId?: string;
  /**
   * ✏️ KA-32 (küçük A paketi): kaydın KENDİ durum rozeti olan yüzeyde
   * (uygunsuzluk · saha turu) 0/0 bilgi taşımaz — çizilmez. Olayda sayaç
   * durumun TA KENDİSİDİR (T2·0), orada 0/0 kalır.
   */
  bosCizilmez?: boolean;
}): React.JSX.Element | null {
  if (bosCizilmez && toplam === 0) return null;
  return (
    <Rozet anlam={dofSayaciAnlami(toplam, acik)} testId={testId}>
      {`${toplam - acik}/${toplam} kapalı`}
    </Rozet>
  );
}
